import { epopsClient } from '@/services/clients'

export default {
  getRestaurantEpops(restaurantId) {
    return epopsClient.get(`/${restaurantId}`, { channel: 'Catering' })
  },
}
